<template>
  <card
    shadow
    class="qr-option-card h-100"
    :class="{ 'qr-option-card--disabled': disabled }"
    body-classes="d-flex flex-column align-items-center text-center"
    @click.native="onSelect"
  >
    <div class="qr-option-card__icon" aria-hidden="true">
      <i :class="icon"></i>
    </div>
    <h3 class="qr-option-card__title">{{ title }}</h3>
    <p class="qr-option-card__text mb-0">{{ text }}</p>
  </card>
</template>

<script>
export default {
  name: 'ProductQrCodeOptionCard',

  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onSelect() {
      if (this.disabled) return
      this.$emit('select')
    },
  },
}
</script>

<style>
.qr-option-card {
  cursor: pointer;
  border: 1px solid #e9ecef;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.qr-option-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(18, 87, 110, 0.12);
}

.qr-option-card--disabled {
  opacity: 0.45;
  filter: grayscale(1);
  cursor: not-allowed;
}

.qr-option-card--disabled:hover {
  transform: none;
  box-shadow: none;
}

.qr-option-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  margin-bottom: 1rem;
  border-radius: 50%;
  background: #eef5f8;
  color: #12576e;
  font-size: 1.75rem;
}

.qr-option-card__title {
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  color: #12576e;
}

.qr-option-card__text {
  color: #525f7f;
  font-size: 0.9rem;
  line-height: 1.45;
}
</style>
